import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
`;

export const Subtitle = styled.div`
  margin-top: 30px;
  color: #c49f3f;
  font-family: "Rockwell";
  font-size: 14px;
  text-transform: uppercase;
`;

export const Question = styled.div`
  margin-top: 16px;
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-bottom: 15px;
    font-size: 24px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 12px;
    font-size: 34px;
  }
`;

export const Desc = styled.div`
  @media (max-width: 1023px) {
    color: #fff;
    font-size: 14px;
    line-height: 1.71;
  }

  @media (min-width: 1024px) {
    color: #c3c3c3;
    font-size: 16px;
    line-height: 1.75;
  }
`;

export const Fields = styled.div`
  width: 100%;

  @media (max-width: 1023px) {
    margin-top: 23px;
    margin-bottom: 10px;
  }

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 10px;
    margin-top: 38px;
    margin-bottom: 18px;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  height: 50px;
  border: solid 1px #818386;
  border-radius: 25px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 13'%3E%3Cpath fill='%23818386' d='m6.494 7.892 4.627-4.633a.87.87 0 0 1 1.235 0 .883.883 0 0 1 0 1.243L7.11 9.747a.871.871 0 0 1-1.2.026L.629 4.502a.875.875 0 0 1 1.235-1.239l4.63 4.629Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position-x: calc(100% - 16px);
  background-position-y: center;

  @media (max-width: 1023px) {
    margin-bottom: 10px;
    background-size: 12px;
  }

  @media (min-width: 1024px) {
    background-size: 15px;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 100%;
  padding-top: 3px;
  color: #818386;
  background-color: transparent;
  font-family: "Rockwell";
  font-weight: 500;
  text-transform: uppercase;
  border: 0 none;
  outline: none;
  appearance: none;

  @media (max-width: 1023px) {
    padding-left: 22px;
    font-size: 13px;
    letter-spacing: 1.3px;
  }

  @media (min-width: 1024px) {
    padding-left: 30px;
    font-size: 14px;
    letter-spacing: 1.4px;
  }
`;

export const Submit = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 3px 18px 0;
  color: #fff;
  background-color: #c49f3f;
  font-family: "Rockwell";
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.4px;
  border-radius: 25px;
`;
